/**
 *
 * A hook that is used to assist with the rendering of breadcrumbs.
 *
 * It returns an array of "crumbs". These crumbs can be looped over and a breadcrumb navigation list can be rendered.
 *
 * @module
 */
import { useSelector } from '../actions/types';
import { getLanguageId } from '../utils/globals';
import * as selectors from '../selectors';
import { useTranslation } from './useTranslation';
import { throwType } from '../types/utils';
/**
 * # useBreadcrumbs
 *
 * The structure of a "crumb" is
 * ```javascript
 * {
 *   linkType: 'category' | 'article';
 *   linkId: string;
 *   title: string;
 * }
 * | {
 *   linkType: 'home';
 *   title: string;
 * };
 * ```
 */
export function useBreadcrumbs() {
    const { t } = useTranslation();
    const crumbs = useSelector((state) => selectors.page.breadcrumbs(state, { languageId: getLanguageId() }));
    function getTitle(c) {
        if ('title' in c)
            return c.title;
        switch (c.linkType) {
            case 'home':
                return t('pageTitles.home');
            case 'error':
                return t('pageTitles.error');
            case 'search':
                return t('pageTitles.search', { searchTerm: c.searchTerm });
            default:
                throwType(c);
        }
    }
    return crumbs.map((c, i, a) => ({
        ...c,
        title: getTitle(c),
        isCurrent: i === a.length - 1,
    }));
}
//# sourceMappingURL=useBreadcrumbs.js.map